export const siteConfig = {
  name: "Swiftle",
  title: "Swiftle - Taylor Swift Song Guessing Game",
  description:
    "Play Swiftle, a daily Taylor Swift song guessing game inspired by Heardle. Listen to short song clips, unlock more seconds, and guess the track in as few tries as possible.",
  baseUrl: "https://swiftle.xyz",
  locale: "en_US",
  language: "en",
  keywords: [
    "Swiftle",
    "Taylor Swift Heardle",
    "Taylor Swift song guessing game",
    "daily Taylor Swift game",
    "music guessing game",
  ],
  howToSteps: [
    "Press play to hear the first second of today's Taylor Swift song.",
    "Search for the artist and title, then submit your guess.",
    "Skip or miss a guess to unlock a longer clip.",
    "Solve the song in six tries or come back tomorrow for a new challenge.",
  ],
  faqs: [
    {
      question: "What is Swiftle?",
      answer:
        "Swiftle is a daily Taylor Swift song guessing game where you identify a track from short audio clips.",
    },
    {
      question: "How do you play Swiftle?",
      answer:
        "Listen to the clip, search for the song title, and submit your guess. Each skipped or incorrect attempt unlocks more of the song.",
    },
    {
      question: "Is there a new Swiftle every day?",
      answer:
        "Yes. The game selects one song for each calendar day, so players can return daily for a new challenge.",
    },
  ],
} as const;
